/**
 * Fantasy Console 0 - Shared Action Group Component
 *
 * Labeled group of icon buttons used across editor action bars.
 */

import editorStyles from '../../styles/editor.module.css'

interface ActionGroupProps {
  label: string
  children: React.ReactNode
}

export function ActionGroup({ label, children }: ActionGroupProps) {
  return (
    <div className={editorStyles.actionGroup}>
      <span className={editorStyles.actionGroupLabel}>{label}</span>
      <div className={editorStyles.buttonGroup}>{children}</div>
    </div>
  )
}

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean
  children: React.ReactNode
}

export function IconButton({
  active,
  children,
  className,
  ...props
}: IconButtonProps) {
  return (
    <button
      className={`${editorStyles.iconButton} ${active ? editorStyles.iconButtonActive : ''} ${className || ''}`}
      {...props}
    >
      {children}
    </button>
  )
}
